import { useSearchParams } from "react-router-dom";
import AccountSettings from "@/components/admin_dashboard/AccountSettings";
import AccountBillingAndPlan from "@/components/admin_dashboard/AccountBillingAndPlan";
import BranchSettings from "@/components/admin_dashboard/BranchSettings";
import CollaboratorAccessCard from "@/components/admin_dashboard/CollaboratorAccessCard";
import Connections from "@/components/admin_dashboard/Connections";
import NotificationSettings from "@/components/admin_dashboard/NotificationSettings";
import TerminologySettings from "@/components/admin_dashboard/TerminologySettings";
import { resolveSettingsPanel } from "@/components/admin_dashboard/settingsNavigation";

interface SettingsPageProps {
  onNavigateToSection?: (section: string, extraParams?: Record<string, string>) => void;
}

const SettingsPage = ({ onNavigateToSection }: SettingsPageProps) => {
  const [searchParams] = useSearchParams();
  const activePanel = resolveSettingsPanel(searchParams.get("settings"));

  if (activePanel === "terminology") return <TerminologySettings />;
  if (activePanel === "branches") return <BranchSettings />;
  if (activePanel === "connectors") {
    return <Connections onNavigateToSection={onNavigateToSection} />;
  }
  if (activePanel === "notifications") return <NotificationSettings />;
  if (activePanel === "billing") return <AccountBillingAndPlan />;
  if (activePanel === "support-access") return <CollaboratorAccessCard />;
  return <AccountSettings />;
};

export default SettingsPage;
